import React from "react";
import Button from "@shared/v2/Button";
import TextButton from "@shared/v2/TextButton";
import { ArrowUpRightFromSquareSolidV6 } from "@shared/v2/Icomoon";
import ZoomCard from "./shared/ZoomCard";

const ForwardCoachingCard = () => (
  <ZoomCard
    actions={
      <>
        <Button
          size="medium"
          schema="secondary"
          className="tw-flex tw-items-center tw-gap-[4px]"
          onClick={() => {}}
        >
          Get Coaching <ArrowUpRightFromSquareSolidV6 />
        </Button>
        <TextButton className="tw-px-0 tw-flex tw-items-center tw-gap-[4px]" size="medium">
          Learn More <ArrowUpRightFromSquareSolidV6 />
        </TextButton>
      </>
    }
    title="Forward Coaching"
    description="Stretch the limits of personal performance, business growth, and financial abundance with forward coaching by Debbie De Grote and her team of coaches."
    imgSrc="/images/bg-card-forward-coaching.png"
    imgClassName="tw-ml-[-12px] tw-mr-[24px]"
  />
);

export default ForwardCoachingCard;
